import { Box, Switch } from '@mui/material';
import NumberInput, { NumberInputProps } from './NumberInput';

interface ToggledNumberInputProps extends NumberInputProps {
  defaultValue: number;
  onChange: (newValue?: number) => void;
}

export const ToggledNumberInput = (props: ToggledNumberInputProps) => {
  const toggled = Number.isFinite(props.value);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <NumberInput {...props} disabled={props.disabled || !toggled} />
      <Switch
        disabled={props.disabled}
        checked={toggled}
        onChange={() =>
          props.onChange(toggled ? undefined : props.defaultValue)
        }
      />
    </Box>
  );
};
